/** VUEX module for state management in app **/
import { MetricsApi } from '@/services/api-metrics.js';

function defaultStateFactory() {
  return {
    filter: {},
    metrics: [],
  };
}

// Local state -----------------------------------------------------
export const state = defaultStateFactory();

// Computed properties of the state --------------------------------
export const getters = {};

// Synchronous mutation of the local state -------------------------
export const mutations = {
  setMetrics(state, metrics) {
    state.metrics = metrics;
  },

  setFilter(state, query) {
    state.filter = query;
  },

  resetState(state, defaultState) {
    state = defaultState;
  },
};

// Async actions ------------------------------
export const actions = {
  parses({ commit, state }, { query }) {
    // store the filter query
    commit('setFilter', query);

    MetricsApi.parses(query)
      .then((parses) => {
        commit('setMetrics', parses);
        return state.metrics;
      })
      .catch((err) => {
        commit('setMetrics', []);
        throw err;
      });
  },

  /**
   * Sets the state back to the default values
   * @returns {Promise}
   */
  reset({ commit }) {
    commit('resetState', defaultStateFactory());
  },
};
